export const previousMonthCost = [
  6400, 6800, 5800, 4200, 5500, 4500, 9700, 10000, 7500, 5600, 4900, 6000, 4100,
  4400, 4300, 5700, 6700, 8500, 5100, 6400, 4200, 7500, 4100, 5900, 6700, 4800,
  5500, 4500, 4700, 5600,
];

export const previousMonthCostSum = previousMonthCost.reduce(
  (acc, val) => acc + val,
  0
);

export const currentMonthCost = [
  6800, 7200, 6200, 5600, 5900, 7900, 10700, 15000, 8250, 6700, 5400, 7600,
  5500, 6800, 5700, 6200, 7300, 9200, 6500, 6800, 5400, 9850, 5250, 6300, 7150,
  6150, 7900, 5900, 6050, 7000,
];

export const restMonthsSums = [151000, 144000, 161300, 168000];

export const currencyCode = "USD";

export const servicesList = [
  "Amazon EC2",
  "Amazon RDS",
  "Amazon Lambda",
  "Amazon S3",
  "Amazon Redshift",
  "Amazon CloudWatch",
  "Amazon SecurityHub",
  "Amazon ApiGateway",
  "Amazon Route53",
  "Amazon SecretsManager",
  "Amazon SNS",
  "Amazon ELB",
  "Amazon ECS",
  "Amazon CloudTrail",
];

export const regionList = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-northeast-3",
  "eu-west-1",
  "ap-southeast-1",
  "eu-west-2",
  "ap-northeast-1",
  "ap-south-1",
  "ap-northeast-2",
  "eu-north-1",
  "global",
  "eu-west-3",
  "ap-southeast-2",
  "eu-central-1",
];

export const topAccountsRatioToCurrentCost = [
  35, 13, 10, 9, 8, 6, 4, 4, 3, 3, 2, 1, 1, 1,
];

export const topServicesRatioToCurrentCost = [
  40, 17, 14, 10, 5, 4, 2, 2, 2, 1, 1, 1, 0.5, 0.5,
];

export const topRegionRatioToCurrentCost = [18, 14, 10, 9, 8, 5, 4, 3.5, 3, 1];

export const topResourcesRatioToCurrentCost = [
  8, 5, 4, 1, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.4, 0.4, 0.4, 0.3, 0.3, 0.2, 0.2,
  0.2, 0.2, 0.2,
];

export const resourceList = [
  "i-w83127897129",
  "rds-273612873",
  "lambda-23712873",
  "i-2613781263",
  "rds-2138712983",
];

export const generateRandomAWSResourceIds = ({ idsCount }) => {
  const resourceTypes = ["i", "rds", "lambda"];
  const resourceIds = [];

  for (let i = 0; i < idsCount; i++) {
    const randomType =
      resourceTypes[Math.floor(Math.random() * resourceTypes.length)];
    const randomId = Math.floor(Math.random() * 10000000000);

    const resourceId = `${randomType}-${randomId}`;
    resourceIds.push(resourceId);
  }

  return resourceIds;
};

export const generateServiceSpecificAWSResourceIds = ({
  idsCount,
  service,
}) => {
  const serviceTypeMap = {
    "Amazon EC2": "i",
    "Amazon RDS": "rds",
    "Amazon Lambda": "lambda",
    "Amazon S3": "s3",
    "Amazon Redshift": "redshift",
    "Amazon CloudWatch": "cloudwatch",
    "Amazon SecurityHub": "securityhub",
    "Amazon ApiGateway": "apigateway",
    "Amazon Route53": "route53",
    "Amazon SecretsManager": "secretsmanager",
    "Amazon SNS": "sns",
    "Amazon ELB": "elb",
    "Amazon ECS": "ecs",
    "Amazon CloudTrail": "cloudtrail",
  };

  const resourceType = serviceTypeMap[service];

  const resourceIds = [];

  for (let i = 0; i < idsCount; i++) {
    const randomId = Math.floor(Math.random() * 10000000000);

    const resourceId = `${resourceType}-${randomId}`;
    resourceIds.push(resourceId);
  }
  return resourceIds;
};

export const resourceToServiceMap = {
  i: "Amazon EC2",
  rds: "Amazon RDS",
  lambda: "Amazon Lambda",
  s3: "Amazon S3",
  redshift: "Amazon Redshift",
  cloudwatch: "Amazon CloudWatch",
  securityhub: "Amazon SecurityHub",
  apigateway: "Amazon ApiGateway",
  route53: "Amazon Route53",
  secretsmanager: "Amazon SecretsManager",
  sns: "Amazon SNS",
  elb: "Amazon ELB",
  ecs: "Amazon ECS",
  cloudtrail: "Amazon CloudTrail",
};

export const spendType = {
  TREND: "TREND",
  BREAKDOWN_SUMMARY: "BREAKDOWN_SUMMARY",
};

export const secondGroupCostRatio = [
  8, 6, 5, 5.5, 4.4, 3, 2, 2, 1.5, 1, 1, 0.5, 0.5, 0.5,
];

export const thirdGroupCostRatio = [
  3, 1.7, 1.6, 1.5, 1.4, 1, 0.6, 0.5, 0.4, 0.3,
];

export const secondLevelResourcesRatioToCurrentCost = [
  3.3, 3.2, 0.7, 0.4, 0.4, 0.4, 0.3, 0.3, 0.3, 0.2, 0.2, 0.2, 0.21, 0.21, 0.2,
  0.2, 0.2, 0.2, 0.2,
];

export const thirdLevelResourcesRatioToCurrentCost = [
  3.1, 1.9, 1.1, 0.9, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.4, 0.4, 0.4, 0.3, 0.3,
  0.2, 0.2, 0.2, 0.2, 0.2,
];
